import {CdkDragDrop, CdkDragEnter, CdkDragStart, CdkDropList, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {Component, EventEmitter, forwardRef, Inject, Input, Output} from '@angular/core';
import {HorizontalPositionOfGroupCreelPosition} from '@domain/textile-data/colored-yarn-set/horizontal-position-of-group-creel-position';
import {HorizontalPositionOfCreelPosition} from '@domain/textile-data/creel/horizontal-position-of-creel-position';
import {CreelPositionDetailsComponent} from '@presentation/pages/textile-data/material-set/add/creel-position-details/creel-position-details.component';
import {each, isEmpty, isEqual, size} from 'lodash-es';
import {asapScheduler} from 'rxjs';
import {CreelPositionsHelper} from '../creel-positions.helper';

@Component({
  selector: 'app-material-type-group',
  templateUrl: './material-type-group.component.html',
  styleUrls: ['./material-type-group.component.scss']
})
export class MaterialTypeGroupComponent {
  @Input() public horizontalPositionOfGroupCreelPosition: HorizontalPositionOfGroupCreelPosition;
  @Input() public horizontalPositionsOfCreelPosition: HorizontalPositionOfCreelPosition[];
  @Input() public canShowError = false;
  @Input() public isDraggingOver = false;
  @Input() public canEditMaterialSet: boolean;
  @Input() public connectedDroplist: CdkDropList[] = [];

  @Output() public groupChanges: EventEmitter<void> = new EventEmitter<void>();

  private readonly creelPositionHelper: CreelPositionsHelper;

  public constructor(@Inject(forwardRef(() => CreelPositionDetailsComponent)) public creelPositionDetailsComponent: CreelPositionDetailsComponent) {
    this.creelPositionHelper = new CreelPositionsHelper();
  }

  public emitGroupChanges(): void {
    this.groupChanges.emit();
  }

  public incrementAmount(event: MouseEvent): void {
    event.stopPropagation();

    this.horizontalPositionOfGroupCreelPosition.amount += 1;

    this.creelPositionDetailsComponent.emitCreelPositionChanges();
  }

  public decrementAmount(event: MouseEvent): void {
    event.stopPropagation();

    const amount = this.horizontalPositionOfGroupCreelPosition.amount;
    this.horizontalPositionOfGroupCreelPosition.amount = !isEqual(amount, 1) ? amount - 1 : 1;

    this.creelPositionDetailsComponent.emitCreelPositionChanges();
  }

  public canDecrementAmount(): boolean {
    return !isEqual(this.horizontalPositionOfGroupCreelPosition.amount, 1) && this.canEditMaterialSet;
  }

  public onMaterialTypeGroupClick(isSelected: boolean, event: MouseEvent): void {
    if (this.canEditMaterialSet) {
      event.stopPropagation();

      const {metaKey, altKey} = event;

      if (metaKey || altKey) {
        this.horizontalPositionOfGroupCreelPosition.isSelected = !isSelected;
      } else {
        const selectedMaterialTypes = this.creelPositionDetailsComponent.getAllSelectedMaterialSetTypesAndGroups(this.creelPositionDetailsComponent.creelPosition.horizontalPositionsOfCreelPosition);
        this.creelPositionDetailsComponent.deselectAllSelectedMaterialTypesAndGroups();

        this.horizontalPositionOfGroupCreelPosition.isSelected = isEmpty(selectedMaterialTypes) || isEqual(size(selectedMaterialTypes), 1) ? !isSelected : true;
      }

      this.selectAllChildMaterialTypesAndGroups(this.horizontalPositionOfGroupCreelPosition.group, isSelected);
    }
  }

  public canShowSelectedIndicator(): boolean {
    return this.horizontalPositionOfGroupCreelPosition.isSelected;
  }

  public canShowWarning(): boolean {
    return this.canShowError && size(this.horizontalPositionOfGroupCreelPosition.group) <= 1;
  }

  public getPositionOfMaterialTypeCreel(materialTypeCreel: HorizontalPositionOfCreelPosition): number {
    return this.creelPositionHelper.getPositionOfMaterialTypeCreelInList(materialTypeCreel, this.horizontalPositionsOfCreelPosition);
  }

  public drop(event: CdkDragDrop<HorizontalPositionOfCreelPosition[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
    this.emitGroupChanges();
  }

  public onDragEntered(event: CdkDragEnter): void {
    this.relinkOwnDroplistReference(event.container);
  }

  public onDragStarted(event: CdkDragStart): void {
    this.relinkOwnDroplistReference(event.source.dropContainer);
  }

  private relinkOwnDroplistReference(droplist: CdkDropList): void {
    const siblings = (droplist.connectedTo as string[]).map((c: string) => (CdkDropList as any)._dropLists.find((d: CdkDropList) => d.id === c)) as CdkDropList<any>[];
    const ref = droplist._dropListRef;
    asapScheduler.schedule(() => {
      ref.connectedTo(siblings.map((list: any) => list._dropListRef));
    });
  }

  private selectAllChildMaterialTypesAndGroups(group: HorizontalPositionOfCreelPosition[], isSelected: boolean): void {
    each(group, (horizontalPositionOfCreelPosition: HorizontalPositionOfCreelPosition) => {
      horizontalPositionOfCreelPosition.isSelected = !isSelected;

      if (horizontalPositionOfCreelPosition.isGroup()) {
        const horizontalPositionOfGroupCreelPosition: HorizontalPositionOfGroupCreelPosition = horizontalPositionOfCreelPosition as HorizontalPositionOfGroupCreelPosition;

        this.selectAllChildMaterialTypesAndGroups(horizontalPositionOfGroupCreelPosition.group, isSelected);
      }
    });
  }
}
